import { ArrowLeftOutlined } from '@ant-design/icons'
import { Col, Skeleton } from 'antd'
import { ColProps } from 'antd/lib/col'
import KCard from 'app/components/UI-Elements/DataDisplay/KCard'
import { ComponentProps } from 'react'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import Button from '../General/Button'

interface Props extends Omit<ColProps, 'title'> {
  render?: boolean
  loading?: boolean
  card?: boolean
  title?: React.ReactNode | string
  subtitle?: React.ReactNode | string
  backIcon?: boolean
  cardProps?: ComponentProps<typeof KCard>
}

const KCol: React.FC<Props> = ({
  loading = false,
  render = true,
  card = false,
  title,
  subtitle,
  backIcon = false,
  cardProps = {},
  ...others
}) => {
  const navigate = useNavigate()
  // Check KTitle and merge if possible
  const getTitle = () => {
    return (
      <Choose>
        <When condition={backIcon}>
          <span>
            <Button className="text-lg" type="link" onClick={() => navigate(-1)}>
              <ArrowLeftOutlined className="mr-3" />
            </Button>
            <span>{title}</span>
          </span>
        </When>
        <Otherwise>{title}</Otherwise>
      </Choose>
    )
  }

  return (
    <Choose>
      <When condition={loading}>
        <Choose>
          <When condition={card}>
            <Col {...others}>
              <KCard
                variant="borderless"
                title={!loading && getTitle()}
                subtitle={subtitle}
                {...cardProps}>
                <Skeleton active={loading} />
              </KCard>
            </Col>
          </When>
          <Otherwise>
            <Col {...others}>
              <Skeleton active={loading} />
            </Col>
          </Otherwise>
        </Choose>
      </When>
      <When condition={render}>
        <Choose>
          <When condition={card}>
            <Col {...others}>
              <KCard
                variant="borderless"
                title={!loading && getTitle()}
                subtitle={subtitle}
                {...cardProps}>
                {others.children}
              </KCard>
            </Col>
          </When>
          <Otherwise>
            <Col {...others} />
          </Otherwise>
        </Choose>
      </When>
      <Otherwise>{null}</Otherwise>
    </Choose>
  )
}

export default KCol
